module.exports = __webpack_public_path__ + "img/M&S.5aad309c.png";